class Map {
	constructor(coords) {
		this.coords = coords;
	}

	init() {
		let self = this;
		ymaps.ready(function () {
			self.map = new ymaps.Map('map_id', {
				center: self.coords || [55.755781, 37.617708],
				zoom: 10,
				controls: ['zoomControl']
			});

			self.map.behaviors.disable('scrollZoom');

			var placemarks = [];

			if (self.coords) {
				placemarks.push({geoObject: self.createPlacemark(self.coords, {name: '', phone: '', address: ''})});
			} else {
				$('#map_id').data('map', self.map);

				$('#map_id').parents('.map-wrapper').find('[data-type="address"]').each(function(index, value) {
					let id = 'address_id_' + index,
						coords = $(this).data('coords').split(',').map((item) => parseFloat(item)),
						name = $(this).find('.address-card__heading').text(),
						address = $(this).find('.address-card__text').children('span').eq(0).html(),
						phone = $(this).find('.address-card__text').children('span').eq(1).html(),
						currentPlacemark = self.createPlacemark(coords, {
							name: name,
							phone: phone,
							address: address
						});
						
					$(this).data('index', id);
					$(this).data('placemark', currentPlacemark);
					placemarks.push({
						id: id,
						geoObject: currentPlacemark
					});
				});
			}

			for (var i = 0; i < placemarks.length; i++) {
				self.map.geoObjects.add(placemarks[i].geoObject);
			}

			$('[data-type="map-mover"]').click(function() {
				let coords = $(this).data('coords').split(',').map((item) => parseFloat(item));
				self.map.setCenter(coords);
			});
		});
	}

	createPlacemark(coords, options) {
		return new ymaps.Placemark(coords, {}, {
			iconLayout: 'default#image',
			iconImageHref: '/static/images/icon-placeholder.svg',
			iconImageSize: [20, 30],
			iconImageOffset: [-10, -15],
			balloonContentLayout: ymaps.templateLayoutFactory.createClass(
				'<div>'+
					'<p>' + options.name + '</p>'+
					'<p>' + options.phone + '</p>'+
					'<p>' + options.address + '</p>'+
				'</div>'
			)
		});
	}
}

$(function() {
	if (! $('#map_id').length) return;

	let coords = $('#map_id').data('coords');
	if (coords)
		coords = coords.split(',').map(i => parseFloat(i));

	(new Map(coords)).init();
});